module.exports = __webpack_public_path__ + "6b5dea63e684e63e5b9ea9f45a877164.svg";